import { filesize } from 'filesize'

export interface DocumentParams {
  id: string | null
  name: string | null
  readableSize: any
  preview: string | null
  uploaded: boolean | null
  url: string | null
  error: boolean | null
  progress: number | null
  description: string | null
}

export function constructorDocument(data: any) {
  const document: DocumentParams = {
    id: data?.uuid,
    name: data?.doc_file_name,
    readableSize: filesize(data?.doc_file_size),
    preview: data?.doc_file_url,
    uploaded: true,
    url: data?.doc_file_url,
    error: false,
    progress: 100,
    description: data?.description
  }

  return document
}
